module.exports = __webpack_public_path__ + "static/media/icon_facebook_contact.186c58da.svg";